import React from 'react';
import PropTypes from 'prop-types';
import { SnapshotTitle } from '../snapshot_title/snapshot_title';
import styles from './simple_snapshot_container.css';

/**
 * SnapshotContainer component
 * @return {Node} SnapshotTitle returns SnapshotContainer component
 */
const SimpleSnapshotContainer = ({ title, children }) => {
    const snapshotTitle = title ? <SnapshotTitle title={title} /> : null;
    return (
        <section className={styles.container}>
            {snapshotTitle}
            {children}
        </section>
    );
};

SimpleSnapshotContainer.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node
};

export { SimpleSnapshotContainer };
